var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": "우편번호",
      "value": _vm.inputData.postcode,
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    }
  }, 'v-text-field', _vm.inputProps, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "rounded-0",
    attrs: {
      "depressed": "",
      "dark": "",
      "color": "grey darken-2"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    }
  }, [_vm._v("검색")])], 1)], 1), _c('v-row', [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": "기본주소",
      "value": _vm.inputData.address1,
      "readonly": ""
    }
  }, 'v-text-field', _vm.inputProps, false))], 1)], 1), _c('v-row', [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": "상세주소"
    },
    model: {
      value: _vm.inputData.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.inputData, "address2", $$v);
      },
      expression: "inputData.address2"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1)], 1), _c('daum-postcode', {
    ref: "daumPostcode",
    on: {
      "change": function change(_ref) {
        var postcode = _ref.postcode,
            address = _ref.address;
        return Object.assign(_vm.inputData, {
          postcode: postcode,
          address1: address
        });
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }